import { SkillLevelValuesEnum, SportsEnum } from 'types/generated/client';
import type { VerificationLevel } from 'types/verification';
import type { FindVenueDetails } from 'components/Find/types';

/** The requester shown in a host's Request review modal / requests sub-card. */
export interface HostRequestPlayer {
  name: string;
  /** Handle without the leading "@" — drives "View profile". */
  username?: string;
  imageUrl: string;
  verificationLevel?: VerificationLevel;
  /** Drives the rating pill colour + (default) label. Omitted when unknown. */
  skillLevel?: SkillLevelValuesEnum;
  /** Numeric scale rating shown as a second pill — e.g. "VAIR 3.5". */
  ratingLabel?: string;
}

/** The listing a request was sent to, as the review modal heads it. */
export interface HostRequestActivity {
  sport: SportsEnum;
  /** e.g. "NTRP 3.5 - 4.0 • Advanced". */
  title: string;
}

/** One chosen time, kept as its display segments so callers render their own separator. */
export interface AvailableOnSlot {
  id: string;
  parts: string[];
}

export const formatAvailableOn = (slots: AvailableOnSlot[]): string =>
  slots.map((slot) => slot.parts.join(' • ')).join(', ');

/** One incoming request as the host reviews it (game or availability). */
export interface HostPlayRequest {
  id: string;
  variant: 'GAME' | 'AVAILABILITY';
  player: HostRequestPlayer;
  message?: string | null;
  /** Availability requests only — the listing shown above the requester. */
  activity?: HostRequestActivity;
  /** Availability requests only — the requester's chosen times, as display segments. */
  availableOn?: AvailableOnSlot[];
  /** Availability requests only — the requester's chosen court. */
  location?: FindVenueDetails;
  /** Game requests only — accepting fills the game, so the API auto-declines the rest. */
  isLastSeat?: boolean;
  /** Availability requests only — names of the neighborhoods the requester picked. */
  neighborhoods?: string[];
}
